import React from 'react'
import ReactDOM from 'react-dom'
import injectTapEventPlugin from 'react-tap-event-plugin'

import createStore from './store/createStore'
import configureAxiosSetting from './api/apiConfiguration'
import './styles/main.css'
// import registerServiceWorker from './registerServiceWorker'
import { unregister } from './registerServiceWorker'
/* import LogRocket from 'logrocket'

if (process.env.NODE_ENV === 'production') {
  LogRocket.init('gxdzhw/mysquare')
}
 */
configureAxiosSetting()

injectTapEventPlugin()

const __DEV__ = process.env.NODE_ENV === 'development'

async function init() {
  // Store Initialization
  // ------------------------------------
  const store = await createStore(window.__INITIAL_STATE__)

  // Render Setup
  // ------------------------------------
  const MOUNT_NODE = document.getElementById('root')

  let render = () => {
    const App = require('./components/App').default
    const routes = require('./routes/index').default(store)

    ReactDOM.render(<App store={store} routes={routes} />, MOUNT_NODE)
  }

  // Development Tools
  // ------------------------------------
  if (__DEV__) {
    if (module.hot) {
      const renderApp = render
      const renderError = error => {
        const RedBox = require('redbox-react').default

        ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
      }

      render = () => {
        try {
          renderApp()
        } catch (e) {
          console.error(e)
          renderError(e)
        }
      }

      // Setup hot module replacement
      module.hot.accept(['./components/App', './routes/index'], () =>
        setImmediate(() => {
          ReactDOM.unmountComponentAtNode(MOUNT_NODE)
          render()
        })
      )
    }
  }

  // Let's Go!
  // ------------------------------------
  render()
  // registerServiceWorker()
  unregister()
}

init()



// WEBPACK FOOTER //
// ./src/index.js